import { useQuery } from '@apollo/client';
import GET_ATENDENCE from './Atendence.Queries';
import { ticketsVariables } from '../../__generated_rental__';

export function useAtendenceQuery(ticketsQueryVariables?: ticketsVariables) {
  const variables = { filters: {}, ...ticketsQueryVariables };
  return useQuery(GET_ATENDENCE, { variables });
}
